export const interventionTemplate = {
  add: {
    label: "Add intervention template",
  },
  category: {
    compliance: "Compliance",
    defect: "Defect",
    identification: "Identification",
  },
  create: {
    label: "Create intervention template",
  },
  createSection: "Create a new section",
  createSubSection: "Create a new subsection",
  editSection: "Edit the section",
  editSubSection: "Edit the subsection",
  dataset: {
    create: {
      label: "Create dataset template",
    },
  },
  delete: {
    label: "Delete intervention template",
  },
  description: {
    label: "Description",
  },
  dynamic: {
    label: "Dynamic",
  },
  informations: {
    label: "Intervention template information",
  },
  name: {
    label: "Name",
  },
  referenceId: "Reference ID",
  type: {
    label: "Type",
  },
  version: {
    currentVersion: "Current version",
    latest: "(latest)",
    otherRevisions: "Other revisions",
    revisionPlural: "Revisions",
    revisionOf: "Revision of",
    createEditableRevision: {
      button: "Create editable revision",
    },
    latestRevision: {
      button: "Go to latest revision",
    },
  },
  form: {
    addForm: "Add intervention form",
    assetTypeFilter: {
      label: "Asset type filters",
    },
    assetTypes: {
      allTypes: {
        label: "All types",
      },
      label: "Asset types",
    },
    category: {
      label: "Category",
    },
    edit: {
      label: "Edit intervention template",
    },
    name: {
      label: "Name",
    },
    description: {
      label: "Description",
    },
    type: {
      label: "Intervention type",
    },
    section: {
      remove: {
        label: "Remove template section",
      },
    },
    state: {
      label: "State",
    },
    usedInIntervention: {
      label: "Used in interventions",
    },
    flags: {
      title: "Repetitions",
      dynamic: "Allow the user to add items to the list.",
      loopOnChildren: "Loop on children",
      displayForCurrentAsset: "Display for current asset",
    },
    organizations: {
      label: "Organizations",
    },
    modules: {
      label: "Modules",
    },
  },
  tableOfContents: "Table of contents",
  error: {
    fileNamesTooLong: "These files name are too long",
    model: "Unable to save intervention template.",
  },
};
